var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBottomHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 4.175C11.6333 3.775 12.3667 3.775 12.9 4.175L19.4 9.05C19.7777 9.33328 20 9.77786 20 10.25V20C20 20.8284 19.3284 21.5 18.5 21.5H14.5C13.6716 21.5 13 20.8284 13 20V17.5C13 16.9477 12.5523 16.5 12 16.5C11.4477 16.5 11 16.9477 11 17.5V20C11 20.8284 10.3284 21.5 9.5 21.5H5.5C4.67157 21.5 4 20.8284 4 20V10.25C4 9.77786 4.22229 9.33328 4.6 9.05L11.1 4.175Z",
    fill: "#B6BCC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBottomHome);
export default __webpack_public_path__ + "static/media/icon_bottom_home.379417de78fa9b30df828cf8b1fd8a70.svg";
export { ForwardRef as ReactComponent };